import React, { useState } from "react";
import AuthShell from "../components/AuthShell";
import AppModal from "../components/AppModal";

export default function ForgotPassword() {
  const [step, setStep] = useState(1);
  const [no_documento, setNoDocumento] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [modal, setModal] = useState({ isOpen: false, title: "", message: "", type: "info" });
  const navigate = require("react-router-dom").useNavigate();

  const showModal = (title, message, type = "info") => {
    setModal({ isOpen: true, title, message, type });
  };

  const handleForgot = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || ""}/api/auth/forgot-password/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ no_documento }),
      });

      const data = await response.json();

      if (response.ok) {
        showModal("Enlace enviado", "Si el documento existe, se envió un enlace de recuperación a su correo registrado.", "success");
        setStep(2);
      } else {
        showModal("Error", data.error || "Error al procesar la solicitud", "error");
      }
    } catch (err) {
      showModal("Error", "Error de conexión", "error");
    }
  };

  const handleReset = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmNewPassword) {
      return showModal("Atención", "Las contraseñas no coinciden", "error");
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || ""}/api/auth/reset-password/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ no_documento, code, new_password: newPassword }),
      });

      const data = await response.json();

      if (response.ok) {
        showModal("Éxito", "Contraseña actualizada exitosamente", "success");
        setTimeout(() => navigate("/login"), 2000);
      } else {
        showModal("Error", data.error || "Código inválido o error en la solicitud", "error");
      }
    } catch (err) {
      showModal("Error", "Error de conexión", "error");
    }
  };

  return (
    <AuthShell
      eyebrow="Recuperacion"
      title="Recuperar contrasena"
      subtitle="La recuperacion tambien usa el mismo formato unificado de campos y botones."
      footerLinks={[
        { to: "/login", label: "Volver a iniciar sesion" },
        { to: "/register", label: "Crear una cuenta" },
      ]}
    >
      {step === 1 ? (
        <form onSubmit={handleForgot} autoComplete="off">
          <div className="app-field">
            <label htmlFor="forgot-doc">No. de Documento</label>
            <input
              id="forgot-doc"
              type="text"
              placeholder="Ingresa tu documento"
              value={no_documento}
              onChange={(e) => setNoDocumento(e.target.value)}
              className="app-input"
              required
            />
          </div>

          <button type="submit" className="app-button app-button--primary">
            Enviar código de recuperación
          </button>
        </form>
      ) : (
        <form onSubmit={handleReset} autoComplete="off">
          <div className="app-field">
            <label htmlFor="reset-code">Código de Recuperación</label>
            <input
              id="reset-code"
              type="text"
              placeholder="Ingresa el código de 6 dígitos"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              className="app-input"
              required
            />
          </div>

          <div className="app-field">
            <label htmlFor="reset-pass">Nueva Contraseña</label>
            <input
              id="reset-pass"
              type="password"
              placeholder="Nueva contraseña"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="app-input"
              required
            />
          </div>

          <div className="app-field">
            <label htmlFor="reset-confirm-pass">Confirmar Nueva Contraseña</label>
            <input
              id="reset-confirm-pass"
              type="password"
              placeholder="Vuelve a ingresar la nueva contraseña"
              value={confirmNewPassword}
              onChange={(e) => setConfirmNewPassword(e.target.value)}
              className="app-input"
              required
            />
          </div>

          <button type="submit" className="app-button app-button--primary">
            Restablecer Contraseña
          </button>
        </form>
      )}

      <AppModal 
        isOpen={modal.isOpen} 
        title={modal.title} 
        message={modal.message} 
        type={modal.type} 
        onClose={() => setModal({ ...modal, isOpen: false })} 
      />
    </AuthShell>
  );
}


